module.exports = __webpack_public_path__ + "img/mural.d34c9083.svg";